import { render } from "./DeleteCommentOverlay.vue?vue&type=template&id=0e4d7946"
import script from "./DeleteCommentOverlay.vue?vue&type=script&lang=js"
export * from "./DeleteCommentOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__